import { Icon, IconProps, MenuItem, MenuItemProps } from "@chakra-ui/react";

export const CustomMenuItem = ({
  children,
  icon,
  ...rest
}: { children: JSX.Element | string; icon: JSX.Element } & MenuItemProps) => {
  return (
    <MenuItem
      h={8}
      minW={"180px"}
      borderRadius={"4px"}
      bgColor={"c-106"}
      color="c-103"
      _hover={{
        bgColor: "c-107",
        color: "brand",
      }}
      p={"16px 12px 16px 8px"}
      icon={icon}
      {...rest}
    >
      {children}
    </MenuItem>
  );
};

export const DownIcon = ({ ...rest }: IconProps) => (
  <Icon width={3.5} height={3.5} viewBox="0 0 14 14" fill="none" {...rest}>
    <path d="M7 9L3 5H11L7 9Z" fill="currentColor" />
  </Icon>
);
